import { tw } from "../../styling";
import type { Icon } from "../svg-icon";

export type IconVariant = "error" | "warning" | "success" | "bankid" | "info" | "info-warning";

export const wrapperClasses = tw`
  rounded-default
  bg-white
  shadow-md
  focus-visible:outline-hidden
  print:shadow-none
`;

export const containerClasses = tw`
  tablet:w-auto
  relative
  flex
  max-h-[95vh]
  w-full
  flex-col
  print:h-auto
`;

export const containerPaddings = tw`
  tablet:p-8
  tablet:pb-20
  laptop:p-20
  p-4
  py-12
  print:p-0
`;

export const contentClasses = tw`
  rounded-default
  tablet:gap-8
  flex
  w-full
  grow
  flex-col
  gap-4
  overflow-x-visible
  overflow-y-auto
  bg-white
  p-0.5
  text-left
  print:h-auto
  print:overflow-visible
  `;

export const iconClasses = tw`
  flex
  size-20
  items-center
  justify-center
  rounded-full
`;

export const footerClasses = tw`
  w-full
  p-0.5
`;

export const headerClasses = tw`
  flex
  w-full
  grow-0
  flex-col
  gap-8
`;

export const modalSize = {
	auto: tw`w-auto max-w-[1400px] print:w-full`,
	small: tw`tablet:w-[560px] w-[560px] max-w-full print:w-full`,
	medium: tw`tablet:w-[800px] w-auto max-w-full print:w-full`,
	full: tw`tablet:w-full tablet:p-0 tablet:py-6 laptop:p-0 laptop:py-6 w-full max-w-[1400px] py-6 print:w-full`,
} as const;

export const iconBackgroundColor: Record<IconVariant, string> = {
	error: "bg-background-critical",
	warning: "bg-background-alert",
	success: "bg-background-success",
	bankid: "bg-background-info",
	info: "bg-background-info",
	"info-warning": "bg-background-alert",
} as const;

export const iconSrc: Record<IconVariant, Icon> = {
	error: "ALERT",
	warning: "WARNING",
	success: "LIST_CHECK",
	bankid: "BANKID",
	info: "INFO",
	"info-warning": "INFO",
} as const;

export const iconColor: Record<IconVariant, string> = {
	error: "text-foreground-critical",
	warning: "text-foreground-alert",
	success: "text-foreground-success",
	bankid: "text-foreground-bank-id",
	info: "text-foreground-bank-id",
	"info-warning": "text-foreground-alert",
} as const;
